import { ErrorHandler, ModuleWithProviders, NgModule, inject, provideAppInitializer } from '@angular/core';
import { ApmErrorHandler, ApmModule, ApmService } from '@elastic/apm-rum-angular';
import { commonEnvConfig } from '../environment';

export type KpMonitoringConfig = { prod: boolean; appName: string };

function initializeApmService(apmService: ApmService, config: KpMonitoringConfig) {
  apmService.init({
    serviceName: config.appName,
    serverUrl: commonEnvConfig.apmServerUrl,
    environment: config.prod ? 'production' : 'stage',
    distributedTracing: true,
  });
}

@NgModule({
  imports: [ApmModule],
})
export class KpMonitoringModule {
  static forRoot(config: KpMonitoringConfig): ModuleWithProviders<KpMonitoringModule> {
    return {
      ngModule: KpMonitoringModule,
      providers: [
        ApmService,
        provideAppInitializer(() => {
          const initializerFn = (
            (apmService: ApmService) => () =>
              initializeApmService(apmService, config)
          )(inject(ApmService));
          return initializerFn();
        }),
        { provide: ErrorHandler, useClass: ApmErrorHandler },
      ],
    };
  }
}
